import React, {
  MouseEvent as ReactMouseEvent,
  useEffect,
  useState,
} from "react";
import { Popover, Slide } from "@mui/material";
import $ from "jquery";
import classnames from "classnames";

import {
  isNotUndefined,
  trackDataMaskIconClickEvents,
  getViewportIsMobile,
  addViewportIsMobileListener,
  track_event
} from "@/shared/FunctionCore";
import {
  MaskDynamicComponentProperties,
  DataMaskingCoreComponentProperties,
  DataMaskingCreditReportsComponentProperties,
  DataMaskExtraProperties,
  DataMaskingComponentProperties
} from "@/IDataMasking";

const MaskDynamicComponent = (properties: MaskDynamicComponentProperties): JSX.Element => {
  const {
    buttonAction,
    buttonLabel,
    text,
    type
  } = properties;

  const [anchorElement, setAnchorElement] = useState<
    HTMLButtonElement | undefined
  >();

  const trackDataMaskingIcon = (currentTarget: HTMLButtonElement) => {
    $(() => {
      if (isNotUndefined(currentTarget)) {
        const dataFieldName = $(currentTarget)
          .parent()
          .parent()
          .attr("data-tracking-name");

        trackDataMaskIconClickEvents(dataFieldName);
      }
    });
  };

  const handleClick = (re: ReactMouseEvent<HTMLButtonElement>) => {
    const currentTarget = re.currentTarget;
    setAnchorElement(currentTarget);
    trackDataMaskingIcon(currentTarget);
  };

  const handleClose = () => setAnchorElement(void 0);

  const anchorElementIsNotUndefined = isNotUndefined(anchorElement);

  const id = anchorElementIsNotUndefined ? "dataMaskingPopover" : "";

  return (
    <div className={"dataMaskingWrapper"}>
      <button
        className={"dataMaskingLockIconWrapper"}
        onClick={handleClick}
        type="button"
      >
        <div className={"dataMaskingLockIcon"} />
      </button>

      <Popover
        anchorEl={anchorElement}
        anchorOrigin={{
          horizontal: "left",
          vertical: "bottom",
        }}
        id={id}
        onClose={handleClose}
        open={anchorElementIsNotUndefined}
      >
        <div className={"dataMaskingModal"}>
          <button
            className={"dataMaskingModalCloseButton"}
            onClick={handleClose}
            type="button"
          />

          <div className={"dataMaskingModalBody"}>
            <div className={"dataMaskingLockIconGray"} />

            <p className={"dataMaskingModalText"}> {text}</p>
          </div>

          <div className={"dataMaskingGetADAndBHooversFreeTrialLinkWrapper"}>
            <a
              className={"dataMaskingGetADAndBHooversFreeTrialLink"}
              onClick={() => {
                buttonAction();
                handleClose();
              }}
            >
              {buttonLabel}
            </a>
          </div>
        </div>
      </Popover>
    </div>
  );
};

const trackDataMaskingIcon = (currentTarget: HTMLButtonElement) => {
  $(() => {
    if (isNotUndefined(currentTarget)) {
      const dataFieldName = $(currentTarget).parent().parent().attr("data-tracking-name");

      trackDataMaskIconClickEvents(dataFieldName);
    }
  });
};

export const DataMaskingCoreComponent = (properties: DataMaskingCoreComponentProperties): JSX.Element => {
  const {
    buttonLabel,
    buttonLink,
    heading,
    showOnTop,
    text
  } = properties;

  const invisible = !showOnTop;

  const [anchorEl, setAnchorEl] = useState<Element | undefined>();
  const [elementWidth, setElementWidth] = useState<number | undefined>();
  const [viewportIsMobile, setViewportIsMobile] = useState(false);

  useEffect(() => {
    setViewportIsMobile(getViewportIsMobile());

    addViewportIsMobileListener((bo) => setViewportIsMobile(bo));
  }, []);

  const handleClose = () => setAnchorEl(void 0);

  return (
    <div className="dataMaskingWrapper">
      <button
        className="dataMaskingLockIconWrapper dataMaskingLockIconWrapper"
        onClick={
          (re: ReactMouseEvent<HTMLButtonElement>) => {
            const currentTarget = re.currentTarget;

            if (showOnTop) {
              window.document
                .querySelectorAll(".dnbHooversFreeTrialCtaLink")
                .forEach((ele) => {
                  const rect = ele.getBoundingClientRect();

                  if (rect.top > 0) {
                    setAnchorEl(ele);

                    const width = ele.clientWidth + 1;

                    setElementWidth(width);
                  }
                });
            } else {
              setAnchorEl(currentTarget);
            }

            trackDataMaskingIcon(currentTarget);
          }
        }
        type="button"
      >
        <div className="dataMaskingLockIcon" />
      </button>

      <Popover
        {
        ...(
          viewportIsMobile
            ?
            {
              "anchorOrigin": {
                "horizontal": "left",
                "vertical": "top",
              }
            }
            : {
              "anchorOrigin": {
                "horizontal": "right",
                "vertical": "top",
              },
              "transformOrigin": {
                "horizontal": "right",
                "vertical": "top",
              }
            }
        )
        }
        BackdropProps={{ "invisible": invisible }}
        anchorEl={anchorEl}
        className={showOnTop ? "dataMaskContainer" : ""}
        id={isNotUndefined(anchorEl) ? "dataMaskingPopover" : void 0}
        onClose={handleClose}
        open={isNotUndefined(anchorEl)}
      >
        <>
          <div className="dataMaskingGetADAndBHooversFreeTrialLinkWrapper">
            <a
              className={classnames("dataMaskingGetADAndBHooversFreeTrialLink", {
                "dataMaskingGetADAndBHooversFreeTrialLinkExtended": showOnTop
              })}
              href={buttonLink}
              onClick={() => {
                track_event(`${buttonLabel} clicked`);
              }}
              style={
                isNotUndefined(elementWidth)
                  ?
                  {
                    "width": `${elementWidth}px`
                  }
                  : void 0
              }
            >
              {buttonLabel}
            </a>
          </div>

          <Slide
            direction="up"
            in={isNotUndefined(anchorEl)}
            mountOnEnter={true}
            unmountOnExit={true}>
            <div
              className={classnames("dataMaskingModal", {
                "dataMaskingModalExtended": showOnTop
              })}
            >
              <button
                className={classnames("dataMaskingModalCloseButton", {
                  "dataMaskingModalCloseButtonExtended": showOnTop
                })}
                onClick={handleClose}
                type="button" />

              <div className="dataMaskingModalBody">
                <div className="dataMaskingLockIconGray" />

                <div className="dataMaskingModalTextSection">
                  <p className="dataMaskingModalHeading">
                    {heading}
                  </p>

                  <p className="dataMaskingModalText">
                    {text}
                  </p>

                </div>
              </div>
            </div>
          </Slide>
        </>
      </Popover>
    </div>
  );
};

export const DataMaskingCreditReportsComponent = (properties: DataMaskingCreditReportsComponentProperties): JSX.Element => (
  <MaskDynamicComponent
    buttonAction={() => {
      window.location.href = properties.buyCreditReportsDirectoryPathRewritten;
    }}
    buttonLabel={properties.dataMaskingRevenueBtnLocalised ?? "Buy Credit Reports"}
    text={properties.dataMaskingRevenueDescriptionLocalised ?? "Looking for more detailed business information? Proactively manage credit relationships with a D&B credit report."}
  />
);

export const DataMaskingComponent = (properties: DataMaskExtraProperties & DataMaskingComponentProperties): JSX.Element =>
  <DataMaskingCoreComponent
    buttonLabel={properties.dnbHooversFreeTrialBtnText ?? "Get a D&B Hoovers Free Trial"}
    buttonLink={properties.hooversFreeTrialDirectoryPathRewritten}
    heading={properties.dnbHooversFreeTrialHeadlineLocalized ?? "D&B Hoovers unlocks contact details and business information"}
    showOnTop={true}
    text={properties.dnbHooversFreeTrialDescriptionLocalized ?? "Get a free trial of D&B Hoovers today and unlock access to the business data that matters to you."}
  />;

export default MaskDynamicComponent;
